import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';

const ProgramManagementErrorDialog = ({ open, onClose }) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="sm">
      <DialogContent>
        <Typography component="p" variant="h5">
          <Trans i18nKey="connectedDrawer.programManagement.error">
            Something went wrong while working with programs on your robot. Check your connection and try again.
          </Trans>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" size="large">
          <Trans i18nKey="button.close" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ProgramManagementErrorDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ProgramManagementErrorDialog;
